export default "__VITE_ASSET__CR0fHQke__"